import "./App.css";
import { RouterProvider } from "react-router-dom";
import router from "./App/Routes";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div className="App">
      <div className="text-regular">
        <Toaster />
        <RouterProvider router={router} />
      </div>
    </div>
  );
}

export default App;
